module.exports = __webpack_public_path__ + "archived-shape.svg?90e60b0d30350b0d0ef31ca0124d9f5e";